import React from "react";
import PropTypes from "prop-types";
import FormRowLabel from "./FormRowLabel";
import FormRowError from "./FormRowError";

const FormRowSplit = (props) => {
    const inputHasError = (index) => {
        if (props.errorMessages
            && props.errorMessages.hasOwnProperty(index)
            && props.errorMessages[index].length
        ) {
            return true;
        }
        return false
    }

    return (<>
        <div className="grid-x grid-margin-x">
            <div className={`cell ${props.leftCellClassName} form-input ${inputHasError(0) ? 'error' : ''}`}>
                <FormRowLabel label={props.labelLeft}/>
                {props.children[0]}
                {props.leftErrorMessage && (
                    <small className="error">
                        {props.leftErrorMessage}
                    </small>
                )}
            </div>
            <div className={`cell ${props.rightCellClassName} form-input ${inputHasError(1) ? 'error' : ''}`}>
                <FormRowLabel label={props.labelRight}/>
                {props.children[1]}
                {props.rightErrorMessage && (
                    <small className="error">
                        {props.rightErrorMessage}
                    </small>
                )}
            </div>
        </div>
        <FormRowError error={props.errorMessages}/>
    </>);
}

FormRowSplit.propTypes = {
    errorMessages: PropTypes.array,
    labelLeft: PropTypes.string,
    labelRight: PropTypes.string,
    leftCellClassName: PropTypes.string,
    rightCellClassName: PropTypes.string,
    leftErrorMessage: PropTypes.string,
    rightErrorMessage: PropTypes.string,
}

FormRowSplit.defaultProps = {
    leftCellClassName: 'small-12 medium-6',
    rightCellClassName: 'small-12 medium-6',
}


export default FormRowSplit;
